/** Display of route in crumbs */
export enum RouteDisplay {
  Settings = 'Settings',
  Payment = 'Payment',
  CustomerManagement = 'Customer Management',
  UserManagement = 'User Management',
  AccountManagement = 'Account Settings',
  AccountPreferences = 'Account Preferences',
  Help = 'Help',
  Home = 'Home',
  Payments = 'Payments',
  Requests = 'Payment Requests',
  PaymentRequest = 'Payment Request',
  Onboarding = 'Onboarding',
}

/** root text of the path */
export enum RoutePath {
  Settings = '/settings',
  Payment = '/payment',
  CustomerManagement = '/customer-management',
  UserManagement = '/user-management',
  AccountManagement = '/account-management',
  AccountPreferences = '/account-preferences',
  Help = '/help',
  Home = '/home',
  Payments = '/all-payments',
  Requests = '/payment-requests',
  PaymentRequest = '/payment-request',
  Onboarding = '/onboarding',
  ApteanAdminUsers = '/aptean-admin-users',
  TenantSettings = '/tenant-settings/:tenantId',
}
